import TextInputField from 'components/TextInputField';
import './JoinBetaTab.css';
import ActionButton from 'components/ActionButton';
import { Controller, useForm } from 'react-hook-form';
import { LOGIN_EMAIL_PLACEHOLDER } from '../../constants';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { AssetUrls } from 'config/assets';

const JOIN_BETA_TITLE = 'Join TradeMagic';
const JOIN_BETA_DESCRIPTION = 'Start by entering your email address.';
const JOIN_BETA_BUTTON = 'Create Account';

export const loginValidationRules = {
  email: {
    required: 'Email is required',
    pattern: {
      value: /^[\w+.-]+@([\w-]+\.)+[\w-]{2,4}$/,
      message: 'Please enter a valid email address',
    },
  },
};

const JoinBetaTab = () => {
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { email: '' } });

  // Show toast notification when there's a validation error
  useEffect(() => {
    if (errors.email) {
      toast.error(errors.email.message || 'Please enter a valid email address');
    }
  }, [errors.email]);

  const onSubmit = (data: { email: string }) => {
    // Navigate to onboarding with the email as a query parameter
    navigate(`/onboarding?email=${encodeURIComponent(data.email)}`);
  };

  return (
    <div className="join-beta">
      <div className="join-beta-messages">
        <div className="join-beta-title">
          {JOIN_BETA_TITLE}
        </div>
        <div className="join-beta-description">
          {JOIN_BETA_DESCRIPTION}
        </div>
      </div>
      <div className="join-beta-input">
        <Controller
          name="email"
          control={control}
          rules={loginValidationRules.email}
          render={({ field }) => (
            <TextInputField
              label={LOGIN_EMAIL_PLACEHOLDER}
              error={Boolean(errors.email)}
              onChange={field.onChange}
            />
          )}
        />
        <ActionButton
          label={JOIN_BETA_BUTTON}
          icon={
            <img
              src={AssetUrls.logos.arevakhachIcon}
              alt="trademagic-icon"
            />
          }
          onPress={handleSubmit(onSubmit)}
        />
      </div>
    </div>
  );
};

export default JoinBetaTab;